import React from 'react';
import './TermsAndConditions.css';
import btn from '../../assets/images/button.svg';
const TermsAndConditions = ({ setShowTermsAndConditions }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    setShowTermsAndConditions(false);
  };

  const handleContainerClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      setShowTermsAndConditions(false);
    }
  };

  return (
    <div className="tnc-modal-container" onClick={handleContainerClick}>
      <div className="tnc-modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content-tnc p-0">
            <div className="modal-header1 d-flex justify-content-md-start justify-content-center">
              <h1 className="modal-title fs-5">Terms and Conditions</h1>
              <button
                type="button"
                aria-label="Close"
                className="btn-close position-absolute end-0 me-4"
                onClick={handleClose}
              >
                <img src={btn}></img>
              </button>
            </div>
            <div className="modal-body p-3">
              <h6>1. SCOPE</h6>
              <p>
                <strong>1.1</strong> JioDAM is a web-based portal provided by
                Jio Platforms Limited and/or its affiliates...
              </p>
              <p>
                <strong>1.2</strong> The Portal allows users to manage digital
                assets including images, videos, audios, and documents.
              </p>
              <p>
                <strong>1.3</strong> Use of the Portal is governed by these
                Terms and Conditions.
              </p>
              <p>
                <strong>1.4</strong> By registering, you consent to the Terms
                and Privacy Policy.
              </p>
              <p>
                <strong>1.5</strong> These Terms are an electronic record as per
                the IT Act, 2000.
              </p>

              <h6>2. PRIVACY AND PROTECTION OF PERSONAL INFORMATION</h6>
              <p>
                <strong>2.1</strong> Please refer to the privacy policy of the
                Portal available online.
              </p>

              <h6>3. MODIFICATIONS</h6>
              <p>
                <strong>3.1</strong> Terms and Services may change. Updates will
                be posted online with notification.
              </p>
              <p>
                <strong>3.2</strong> Features and content may be modified or
                removed at any time.
              </p>

              <h6>4. LINKS TO THIRD PARTY SITES AND APPLICATIONS</h6>
              <p>
                <strong>4.1</strong> Portal may contain links to external sites.
                Company is not responsible for those contents.
              </p>
              <p>
                <strong>4.2</strong> Dealings with third parties are solely
                between the user and the advertiser.
              </p>
              <p>
                <strong>4.3</strong> Linked site usage is governed by their own
                policies. Company disclaims responsibility.
              </p>

              <h6>5. INTELLECTUAL PROPERTY RIGHTS</h6>
              <p>
                <strong>5.1</strong> Company owns all intellectual property in
                the Portal except for user content.
              </p>

              <h6>6. USE LIMITATIONS</h6>
              <p>
                <strong>6.1</strong> Services must be used for permitted
                purposes only.
              </p>
              <p>
                <strong>6.2</strong> Users must not use the Portal unlawfully or
                harmfully.
              </p>
              <p>
                <strong>6.3</strong> Interfering with the Portal's operations is
                prohibited.
              </p>
              <p>
                <strong>6.4</strong> Users under 18 or with legal
                disqualifications must not use the Portal.
              </p>

              <h6>7. USER NAMES AND PASSWORDS</h6>
              <p>
                <strong>7.1</strong> Sign-in requires valid credentials.
              </p>
              <p>
                <strong>7.2</strong> Users must provide a valid email address.
              </p>
              <p>
                <strong>7.3</strong> Company may suspend access if credentials
                are misused.
              </p>
              <p>
                <strong>7.4</strong> Users must keep passwords confidential.
              </p>

              <h6>8. GENERAL</h6>
              <p>
                <strong>8.1</strong> Users agree to follow prohibited content
                rules.
              </p>
              <p>
                <strong>8.2</strong> Use Restriction: Certain users are barred
                by law from using the Portal.
              </p>
              <p>
                <strong>8.3</strong> Services may be paid or free.
              </p>
              <p>
                <strong>8.4</strong> Third-party fees may apply.
              </p>
              <p>
                <strong>8.5</strong> Automatic updates may be required.
              </p>
              <p>
                <strong>8.6</strong> User must provide accurate information.
              </p>

              <h6>9. LIABILITY DISCLAIMER</h6>
              <p>
                <strong>9.1</strong> Company is not liable for indirect or
                incidental damages.
              </p>
              <p>
                <strong>9.2</strong> Users must maintain secure equipment.
              </p>
              <p>
                <strong>9.3</strong> Users are responsible for shared content.
              </p>
              <p>
                <strong>9.4</strong> No warranties are provided.
              </p>
              <p>
                <strong>9.5</strong> Company not responsible for unauthorized
                data access or third-party content.
              </p>
              <p>
                <strong>9.6</strong> Company is not liable for losses from use
                of the Portal.
              </p>

              <h6>10. TERMINATION</h6>
              <p>
                <strong>10.1</strong> Services may be terminated at Company's
                discretion.
              </p>
              <p>
                <strong>10.2</strong> Violations of Terms can lead to access
                suspension.
              </p>

              <h6>11. GOVERNING LAW AND DISPUTE RESOLUTION</h6>
              <p>
                <strong>11.1</strong> Governed by Indian law. Mumbai courts have
                exclusive jurisdiction.
              </p>

              <h6>12. FORCE MAJEURE</h6>
              <p>
                <strong>12.1</strong> Company not liable for service
                unavailability due to force majeure.
              </p>

              <h6>13. SEVERABILITY</h6>
              <p>
                <strong>13.1</strong> If any term is invalid, rest remain
                enforceable.
              </p>

              <h6>14. CONTACT DETAILS</h6>
              <p>
                <strong>14.1</strong> Contact: Mrs. Radha Nair,
                grievance.officer@jio.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
